import React from "react";
import Sidebar from "../../../components/Sidebar";
import MentorProfileSettingsComponent from "../../../components/profile/MentorProfileSettingsComponent";

function MentorProfileSettings() {
  return (
    <Sidebar>
      <MentorProfileSettingsComponent />
    </Sidebar>
  );
}

export default MentorProfileSettings;
